/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tradenamebrandname3Inputs */

const en_tradenamebrandname3 = /** @type {(inputs: Tradenamebrandname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade Name / Brand Name`)
};

const de_tradenamebrandname3 = /** @type {(inputs: Tradenamebrandname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsname / Markenname`)
};

/**
* | output |
* | --- |
* | "Trade Name / Brand Name" |
*
* @param {Tradenamebrandname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const tradenamebrandname3 = /** @type {((inputs?: Tradenamebrandname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tradenamebrandname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tradenamebrandname3(inputs)
	return de_tradenamebrandname3(inputs)
});
export { tradenamebrandname3 as "tradeNameBrandName" }